
export const theme_ns: ThemeNS = 'mylly2023';
